import { Day } from '@/api/restaurants/types/restaurant-types'

export function parseDayOfWeek(dayNumber: number): Day | null {
    switch (dayNumber) {
        case 0:
            return 'sunday'
        case 1:
            return 'monday'
        case 2:
            return 'tuesday'
        case 3:
            return 'wednesday'
        case 4:
            return 'thursday'
        case 5:
            return 'friday'
        case 6:
            return 'saturday'
        case 7:
            return 'sunday'
        default:
            return null
    }
}
